import { useNavigate, useLocation } from 'react-router-dom';

const navItems = [
  { section: 'Pilotage', items: [
    { path: '/dashboard', icon: '\u25A6', label: 'Dashboard' },
    { path: '/traceability', icon: '↗', label: 'Traçabilité FPT' },
    { path: '/suivi-fpt', icon: '\u25A4', label: 'Suivi FPT' },
    { path: '/dossier', icon: '\u25A4', label: 'Mon dossier FPT' },
    { path: '/declarations', icon: '\u{1F4DD}', label: 'Déclarations' },
    { path: '/month-end', icon: '▤', label: 'Déclarations mensuelles' },
    { path: '/debit-notes', icon: '\u25A4', label: 'Notes de débit' },
  { path: '/payments', icon: '\u25C6', label: 'Paiements' },
    { path: '/quittances', icon: '\u25A3', label: 'Quittances' },
  ]},
  { section: 'Établissements', items: [
    { path: '/establishments', icon: '\u2302', label: 'Mes établissements' },
    { path: '/licenses', icon: '\u{1F4CB}', label: 'Licences' },
    { path: '/renewals', icon: '\u{1F4C5}', label: 'Renouvellements' },
  ]},
  { section: 'Communication', items: [
    { path: '/messages', icon: '\u{1F4AC}', label: 'Messages' },
    { path: '/video', icon: '\u{1F4F9}', label: 'Vidéoconférence' },
  ]},
  { section: 'Suivi', items: [
    { path: '/history', icon: '\u25F7', label: 'Historique' },
    { path: '/reports', icon: '\u{1F4CA}', label: 'Rapports' },
    { path: '/settings', icon: '\u2699', label: 'Paramètres' },
  ]},
];

const pageTitles: Record<string, string> = {
  '/dashboard': 'Dashboard',
  '/suivi-fpt': 'Suivi FPT',
 '/traceability': 'Traçabilité FPT',
  '/dossier': 'Mon dossier FPT',
  '/declarations': 'Déclarations',
  '/month-end': 'Déclarations mensuelles FPT',
  '/debit-notes': 'Notes de débit',
  '/payments': 'Paiements',
  '/quittances': 'Quittances',
  '/establishments': 'Mes établissements',
  '/licenses': 'Licences',
  '/renewals': 'Renouvellements',
  '/messages': 'Messages',
  '/video': 'Vidéoconférence',
  '/history': 'Historique',
  '/reports': 'Rapports',
  '/settings': 'Paramètres',
};

interface Props {
  ownerName: string;
  establishmentCount: number;
  onLogout: () => void;
  children: React.ReactNode;
}

export default function Sidebar({ ownerName, establishmentCount, onLogout, children }: Props) {
  const navigate = useNavigate();
  const location = useLocation();
  const title = pageTitles[location.pathname] || 'Portail Assujetti';

  const toggleMenu = () => {
    document.getElementById('side')?.classList.toggle('open');
  };

  const goTo = (path: string) => {
    navigate(path);
    document.getElementById('side')?.classList.remove('open');
  };

  return (
    <div className="app">
      <aside className="side" id="side">
        <div className="brand">
          <div className="logo">FPT</div>
          <div>
            <h1>Portail Assujetti V4</h1>
            <small>FPT &amp; Licences</small>
          </div>
        </div>

        {navItems.map(section => (
          <div key={section.section}>
            <div className="nav-title">{section.section}</div>
            {section.items.map(item => (
              <button
                key={item.path}
                className={`nav-btn${location.pathname === item.path ? ' active' : ''}`}
                onClick={() => goTo(item.path)}
              >
                {item.icon} {item.label}
              </button>
            ))}
          </div>
        ))}

        <div className="userbox">
          <strong>{ownerName}</strong><br />
          <small>Propriétaire · {establishmentCount} établissement{establishmentCount !== 1 ? 's' : ''}</small>
        </div>
      </aside>

      <div className="main-area">
        <header className="top">
          <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
            <button className="menu-toggle" onClick={toggleMenu}>&#9776;</button>
            <div>
              <strong>{title}</strong>
              <div className="sub">Compte Assujetti</div>
            </div>
          </div>
          <div className="top-actions">
            <button className="btn" onClick={onLogout}>Déconnexion</button>
          </div>
        </header>
        <div className="content">
          {children}
        </div>
      </div>
    </div>
  );
}
